import { createSlice } from '@reduxjs/toolkit';
import {getTs} from "../utils";
import axios from "../axios-pogo";
import {showError} from "./coreSlice";

const getCachedHiddenMarkers = () => {
	const hiddenRaw = localStorage.getItem("hiddenMarkers");
	const deleteBefore = getTs() - 60*60*24;
	const markers = hiddenRaw ? JSON.parse(hiddenRaw) : {};
	Object.keys(markers).forEach(marker => {
		if( markers[marker] < deleteBefore )
			delete(markers[marker]);
	});
	return markers;
};

const markerSlice = createSlice({
	name: 'marker',
	initialState: {
		gyms: {},
		pokemon: {},
		stops: {},

		portals: {}, /* in Ingress, not in PoGo */

		hidden: getCachedHiddenMarkers(),
		giovanni: {}
	},
	reducers: {
		addGyms(state, action) { // actual gym objects
			if( action.payload )
				action.payload.forEach(gym => state.gyms[gym.gym_id] = gym);
		},
		addStops(state, action) {
			if( action.payload )
				action.payload.forEach(stop => state.stops[stop.pokestop_id] = stop);
		},
		editStop(state, action) {
			state.stops[action.payload.pokestop_id] = action.payload;
		},
		addPokemon(state, action) {
			if( action.payload )
				action.payload.forEach(pokemon => state.pokemon[pokemon.encounter_id] = pokemon);
		},
		addPortals(state, action) {
			if( action.payload )
				action.payload.forEach(portal => state.portals[portal.id] = portal);
		},
		addHidden(state, action) { state.hidden[action.payload] = Math.round(getTs()); },
		setHidden(state, action) { state.hidden = action.payload; },
		setGiovanni(state, action) { if( action.payload ) state.giovanni = action.payload; },
	}
});

export const { addGyms, addPokemon, addStops, addPortals, addHidden, setHidden, editStop, setGiovanni }
	= markerSlice.actions;

export const hideMarker = (id) => {
	return (dispatch, getState) => {
		dispatch(addHidden(id));
		const state = getState();
		localStorage.setItem("hiddenMarkers", JSON.stringify(state.marker.hidden));
	}
};

export const clearHiddenMarkers = () => {
	return (dispatch, getState) => {
		dispatch(setHidden({}));
		localStorage.setItem("hiddenMarkers", JSON.stringify({}));
	}
};


export const submitGiovanni = (pokestop_id, isGiovanni) => (dispatch, getState) => {
	axios.post("/mod/pokemon/map/ajax/submit-giovanni.php", {pokestop_id, isGiovanni}).then(result => {
		// dispatch(pendingSubmissionRemoved(key));
		if( result.data.giovanni ) {
			console.log("Success: ", result);
			dispatch(setGiovanni(result.data.giovanni));
		} else {
			console.log("Error submitting boss: ", result.data.error);
			dispatch(showError("Error submitting boss. Please refresh page."));
		}
	}).catch(error => {
		console.log("Error submitting boss: ", error);
		dispatch(showError("Error submitting boss. Please refresh page."));
	});
};

export const updateGym = gym_id => (dispatch, getState) => {
	axios.post("/mod/pokemon/map/ajax/update-gym.php", {gym_id});
};

export default markerSlice.reducer;